export type PredicateKind = "visibility" | "requirement";

export type AiContext =
  | { kind: "questionnaire"; id: number; label: string }
  | { kind: "questionGroup"; id: number; label: string }
  | { kind: "question"; id: number; label: string }
  | {
      kind: "predicate";
      scope: "questionnaire" | "questionGroup";
      scopeId: number;
      scopeLabel: string;
      predicateKind: PredicateKind;
      location: string;
      targetKind: "question" | "questionGroup";
      targetId: number;
      targetLabel: string;
    };

const predicatePhrase = (kind: PredicateKind) => (kind === "visibility" ? "visible when" : "required when");

export const contextStarterPrompt = (ctx: AiContext): string => {
  switch (ctx.kind) {
    case "questionnaire":
      return `In questionnaire "${ctx.label}", I want to `;
    case "questionGroup":
      return `In question group "${ctx.label}", I want to `;
    case "question":
      return `For the question "${ctx.label}", I want to `;
    case "predicate": {
      const scopeKind = ctx.scope === "questionnaire" ? "questionnaire" : "question group";
      const targetKind = ctx.targetKind === "question" ? "question" : "question group";
      const predicateNoun = ctx.predicateKind === "visibility" ? "visibility" : "requirement";
      return (
        `In ${scopeKind} "${ctx.scopeLabel}" (id ${ctx.scopeId}), ` +
        `set the ${predicateNoun} predicate of ${ctx.location} — ` +
        `${targetKind} "${ctx.targetLabel}" (id ${ctx.targetId}) — ` +
        `so it is ${predicatePhrase(ctx.predicateKind)} `
      );
    }
  }
};
